module.exports = __webpack_public_path__ + "static/img/12.ffe9ec2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/12.png
// module id = w9QZ
// module chunks = 0